module.exports = __webpack_public_path__ + "68addd473f6e83737d19725fccd7a673.png";